import React from "react";
import Admins from "../../features/admins/Admins";

export default function AdminsPage() {
  return (
    <div>
      <Admins />
    </div>
  );
}
